<script setup lang="ts">
  import { computed } from "vue";
  import { Separator } from "@/components/ui/separator";
  import StatsList from "./components/StatsList.vue";
  import type { Histo, HistoScreenout, HistoDropout } from "@/components/Admin/Histo/HistoDataTable/types";

  const props = defineProps<{
    histo: Histo;
  }>();

  const screenouts = computed<HistoScreenout[]>(() => {
    try {
      return JSON.parse(props.histo.questio_screenouts || "[]");
    } catch {
      return [];
    }
  });

  const dropouts = computed<HistoDropout[]>(() => {
    try {
      return JSON.parse(props.histo.questio_dropouts || "[]");
    } catch {
      return [];
    }
  });
</script>

<template>
  <div class="space-y-6">
    <StatsList
      title="Top screenouts"
      :items="screenouts"
      item-type="screenout"
      empty-message="No screenouts available"
      variant="red" />

    <Separator />

    <StatsList
      title="Top dropouts"
      :items="dropouts"
      item-type="dropout"
      empty-message="No dropouts available"
      variant="amber" />
  </div>
</template>
